<section class="footer">
  <div class="wrapper">
    <div  fxLayout="row" fxLayoutAlign="center center" fxLayout="row" fxLayout.xl="row" fxLayout.lg="row"
      fxLayout.md="row" fxLayout.sm="row" fxLayout.xs="column">
      <div  class="sub" fxLayout="column" >
        <form class="form-section" [formGroup]="subscriptionForm">
          <div class="custom-form-group">
            <div class="custom-form-control">
              <mat-form-field appearance="outline">
                <input type="email" matInput placeholder="Enter your email" formControlName="email">
              </mat-form-field>
              <button type="submit" class="btn-white" (click)="addNewsLetterSubscription()">Subscribe</button>
            </div>
          </div>
        </form>
      </div>
    </div>
    <div class="footer_links" fxLayoutAlign="start stretch" fxLayout="row" fxLayout.xl="row" fxLayout.lg="row"
      fxLayout.md="row" fxLayout.sm="row" fxLayout.xs="column">
      <div fxLayout="column" fxFlex.xl="25" fxFlex.lg="25" fxFlex.md="25" fxFlex.sm="50" fxFlex.xs="100" fxFlexFill>
        <img src="../../../../../assets/images/logo.png" alt="img">
        <p>Narmetta is a reformist village loacted in the district of Siddipet as one of the most promising villages of
          telegana state.narmetta is experiencing the multidimensonal devlepoment with all facilitices and infrastrutre
        </p>
      </div>
      <div class="pl40" fxLayout="column" fxFlex.xl="25" fxFlex.lg="25" fxFlex.md="25" fxFlex.sm="50" fxFlex.xs="100"
        fxFlexFill>
        <h4 class="footer-heading">QUICK LINKS</h4>
        <ul>
          <li><a [routerLink]="['/About']">About Village</a></li>
          <li><a [routerLink]="['/governance_settings']">Village governance</a></li>
          <li><a [routerLink]="['/government_offices_settings']">government_offices</a></li>
          <li><a [routerLink]="['/public_places_settings']">Public Places</a></li>
          <li><a [routerLink]="['/village_virtual_offices']">Village Virtural Offices</a></li>
          <li><a [routerLink]="['/initiatives_settings']">Initiatives</a></li>
          <li><a [routerLink]="['/transportation_facilities_settings']">Transportation</a></li>
          <li><a [routerLink]="['/events_settings']">Events</a></li>

        </ul>
      </div>
      <div fxLayout="column" fxFlex.xl="20" fxFlex.lg="20" fxFlex.md="20" fxFlex.sm="50" fxFlex.xs="100" fxFlexFill>
        <h4 class="footer-heading">Village Virtual Offices</h4>
        <ul>
          <li><a href="https://tweb.telangana.gov.in/" target="_blank">Link to T-web</a></li>
          <li><a href="https://uidai.gov.in/" target="_blank">Link to Aadhar website</a></li>
          <li><a href="https://it.telangana.gov.in/t-app-folio/" target="_blank">Link to T-app Website</a></li>
          <li><a href="https://www.telangana.gov.in/government/mps/" target="_blank">MLA's/Mp's Website links</a></li>
          <li><a href="https://ts.meeseva.telangana.gov.in/meeseva/home.htm?/" target="_blank">e-save link</a></li>
          <li><a href="https://covid19.telangana.gov.in/" target="_blank">Guideliness for Corona Virus</a></li>
          <li><a href="https://rti.gov.in/" target="_blank">Link to information act</a></li>
          <li><a href="https://www.nic.in/projects/open-government-data-ogd-platform-india/" target="_blank">Link to open govData</a></li>
          <li><a href="https://www.telangana.gov.in/" target="_blank">Link to TS Govt</a></li>
          <li><a href="https://www.mygov.in/" target="_blank">My Govt link</a></li>
          <li><a href="https://www.makeinindia.com/" target="_blank">Made in india link</a></li>
        </ul>
      </div>
      <div fxLayout="column" fxFlex.xl="30" fxFlex.lg="30" fxFlex.md="30" fxFlex.sm="50" fxFlex.xs="100" fxFlexFill>
        <div fxLayout="column" fxFlex="25">
          <h4 class="footer-heading">Contact</h4>
          <div class="ft-text">
            <h6 class="address-line"> <img src="../../../../../assets/images/icons/loaction.png" alt="" srcset="">
           Narmetta is an Madal in Warganal District of Telengana State ,India
            </h6>
            <h6 class="address-line"> <img src="../../../../../assets/images/icons/call.png" alt="" srcset=""> 
             +91 888 888 8888</h6>
            <h6 class="address-line"> <img src="../../../../../assets/images/icons/mail.png" alt="" srcset=""> 
              info@narmetta.com</h6>
          </div>
          <div class="social_links">
            <h2 class="footer_heading">SOCIAL</h2>
            <ul>
              <li>
                <a href="https://www.facebook.com/PeacefullNarmetta" target="_blank">
                  <img src="../../../../../assets/images/icons/facebook.svg" alt="facebook of joondaloop">
                </a>
                <a href="https://www.linkedin.com/company/engrin-services-pvt-ltd" target="_blank">
                  <img src="../../../../../assets/images/icons/linkedin.svg" alt="linkedin of narmetta">
                </a>
                
              </li>
              </ul>
              </div>
        </div>
      </div>
    </div>
    
  </div>
  
</section>
<section class="footer_sec">
  <div class="footer_overlay">
  <p class="copy_right">All copyrights reserved © 2020 | Narmetta Grampanchayat, Telangana</p>
  </div>
</section>